/**
 * Belgium-only deployment for now: the feed call sends a hardcoded IANA zone plus the device's actual
 * UTC offset. The kiosk device physically sits in Belgium, so its offset equals Brussels' and stays
 * DST-correct without a timezone library. Replace KIOSK_TIMEZONE with real device-zone detection later.
 */
export const KIOSK_TIMEZONE = 'Europe/Brussels';

/** Current device UTC offset formatted as `±HH:MM` (e.g. `+02:00`). */
export const getKioskTimezoneOffset = (date: Date = new Date()) => {
  // getTimezoneOffset() returns minutes BEHIND UTC, so negate to get the real offset.
  const totalMinutes = -date.getTimezoneOffset();
  const sign = totalMinutes >= 0 ? '+' : '-';
  const abs = Math.abs(totalMinutes);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${sign}${hh}:${mm}`;
};
